import React from "react";
import style from "./LoadingIcon.module.scss";
import LoadingMdiIcon from "mdi-react/LoadingIcon";

export function LoadingIcon() {
  return <LoadingMdiIcon className={style.loadingIcon} />;
}
